
import { defineComponent } from 'vue'
import Badge from 'primevue/badge'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import DetailsCard from './DriversManagementUseModeDetailsCard.vue'
import RolesCard from './DriversManagementRolesCard.vue'
import ConstraintsCard from './DriversManagementConstraintsCard.vue'
import KnHint from '@/components/UI/KnHint.vue'

export default defineComponent({
    name: 'business-model-catalogue-detail',
    components: {
        Badge,
        TabView,
        TabPanel,
        DetailsCard,
        RolesCard,
        ConstraintsCard,
        KnHint
    },
    props: {
        selectedMode: {
            type: Object,
            required: false
        },
        roles: {
            type: Array,
            required: true
        },
        constraints: {
            type: Array,
            required: true
        },
        selectionTypes: {
            type: Array,
            required: true
        },
        layers: {
            type: Array,
            required: true
        },
        isDate: {
            type: Boolean,
            required: true
        },
        disabledRoles: {
            type: Array,
            required: true
        },
        lovs: {
            type: Array,
            required: true
        },
        showMapDriver: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mode: {} as any
        }
    },
    computed: {
        invalidModes(): number {
            return this.mode.numberOfErrors
        },
        invalidRoles(): boolean {
            return this.mode.associatedRoles.length === 0
        },
        availableRoles(): any {
            return this.roles?.filter((role: any) => this.disabledRoles.findIndex((disabledRole: any) => role.id === disabledRole?.id) < 0)
        }
    },
    watch: {
        selectedMode() {
            this.mode = this.selectedMode as any
        }
    },
    mounted() {
        if (this.selectedMode) {
            this.mode = this.selectedMode as any
        }
    },
    methods: {}
})
